export enum Role {
  USER = "USER",
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  MODERATOR = "MODERATOR",
}

type RoleValues = `${Role}`;

export interface IRole {
  id: number;
  value: RoleValues;
  description: string;
}
